import * as types from "../actions/actiontype";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as constants from '../constants'
const initialState = {
    utmSource: ""
};

initialState.modalState = {
    showMedicalQuote: true,
    showService: false,
    showSearch: false,
    memberBasePremModal: false,
    planTobModal: false,
    planCompare: false,
    showPremiumBreakDown: false
}

initialState.HAADSteps = [

    { label: 'Basic Info', image: 'img/info.png' },
    { label: 'Member Info', image: 'img/img1.png' },
    { label: 'Plan', image: 'img/summary-18.png' },
    { label: 'Full Member Details', image: 'img/4926094.png' },
    { label: 'KYC & Payment', image: 'img/2543190.png' },

]
initialState.isFromSearch = false;
initialState.NeSteps = [

    { label: 'Basic Info', image: 'img/info.png' },
    { label: 'Member Info', image: 'img/img1.png' },
    { label: 'Plan', image: 'img/summary-18.png' },
    // { label: 'Full Member Details', image: 'img/4926094.png' },
    { label: 'KYC & Payment', image: 'img/2543190.png' },

]
initialState.quoteSearchParams = {
    quoteNo: null,
    enqNo: null,
    mobileNo: null,
    email: null,
}
initialState.currentDocQuoteMembers = {}
initialState.planType = {}
initialState.quoteSearchResult = []
initialState.paymentInformation = {
    customerEmail: null,
    customerPhone: null,
    customerName: null,
    referenceId: null,
    encryptedEnquiryRefId1: null,
    encryptedEnquiryRefId2: null,
    referenceText: null
}
initialState.paymentResponse = {
    error: null
}
initialState.payment = {
    paymentMode: appConstants.PAYMENT_MODE_ONLINE_PAYMENT,
    termsCond: false,
    plan: null,
    netToPay: null,
    paymentDone: false,
}
initialState.activeStep = 0
initialState.productId = null

initialState.confirmPopup = {
    showConfirmPopup: false,
    message: null,
    resolve: null,
    showYes: false,
    showNo: false,
    showOk: false,
    isComp: false,

}
initialState.prospectInformation = {
    quotationNo: null,
    memberId: null,
    photoId: null,
    photoName: null,
    photoSrc: null,
    salutation: null,
    firstName: null,
    middleName: null,
    lastName: null,
    memberDateOfBirth: null,
    age: null,
    ageInMonths: null,
    isAgeLessThan1: false,
    isPrincipal: false,
    isInsuredYN: false,
    relation: null,
    principal: null,
    emiratesId: null,
    visaEmirates: null,
    gender: null,
    nationality: null,
    maritalStatus: null,
    isSpouseMarried: false,
    passportNo: null,
    mobile: null,
    email: null,
    salaryBand: null,
    salary: null,
    isSalaryZero: null,
    minSalary: null,
    maxSalary: null,
    height: null,
    weight: null,
    bmi: null,
    profession: null,
    idType: constants.ID_TYPE_EMIRATES_ID,
    dhaMemberType: null,
    dhaMemberId: null,
    dhaVerified: null,
    workEmirate: null,
    workLocation: null,
    residentEmirate: null,
    residentLocation: null,
    birthCertificate: null,
    uidNumber: null,
    dhaStatus: null,
    visaType: null,
    isNewEntry: false,
    isResident: false,
    firstPolicy: true,
    previousInsuranceCompany: null,
    previousInsuranceNumber: null,
    previousInsuranceExpiryDt: null,
    entryDate: null,
    isFirstPolicy: true,
    premiumPerPerson: null,
    extraPremium: null,
    maternityPremium: null,
    autoLoadingPerc: null,
    autoLoadingAmt: null,
    uwLoadingPerc: null,
    uwLoadingAmt: null,
    netLoadingPerc: null,
    netLoadingAmt: null,
    discountPerc: null,
    discountAmt: null,
    netPremium: null,
    showMemberInformation: false,
    basmaFee: 19,
    haadPenalty: 0,
    hcvFee: 18,
    finalPenalty: 0,
    cutOffDate: null,
    elapsedDays: null,
    showDubaiRegionFee: false,
    showAbuDhabiRegionFee: false,
    showDOHPenaltyButton: false,
    isLocationMandatory: true,
    documentType: null,
    isPrincipalExisting: "N",
    isDohVerified: null,
    visaFileNo: null,
    ageIsLessThan6Months: null,
    category: null,
    icpFee: null,
    cocVerifiedYN: null,
    category: null,
    changeOfCategoryHasError: false,
    isSaved: false,
}
initialState.dependentInformation = {
    policyNo: null,
    memberId: null,
    photoId: null,
    photoName: null,
    photoSrc: null,
    salutation: null,
    firstName: null,
    middleName: null,
    lastName: null,
    dateofBirth: null,
    age: null,
    ageInMonths: null,
    isAgeLessThan1: false,
    isPrincipal: false,
    relation: null,
    category: null,
    initialCategory: null,
    principal: null,
    emiratesId: null,
    visaEmirates: null,
    gender: null,
    nationality: null,
    maritalStatus: null,
    passportNo: null,
    mobile: null,
    email: null,
    salaryBand: null,
    salary: null,
    minSalary: null,
    maxSalary: null,
    height: null,
    weight: null,
    bmi: null,
    profession: null,
    idType: null,
    dhaMemberType: null,
    dhaMemberId: null,
    dhaVerified: null,
    workEmirate: null,
    workLocation: null,
    residentEmirate: null,
    residentLocation: null,
    birthCertificate: null,
    uidNumber: null,
    cutOffDate: null,
    elapsedDays: null,
    dhaStatus: null,
    firstPolicy: true,
    previousInsuranceCompany: null,
    previousInsuranceNumber: null,
    previousInsuranceExpiryDt: null,
    entryDate: null,
    visaExpiryDate: null,
    isFirstPolicy: true,
    isLocationMandatory: true,
    employeeId: null,
    firstNameAr: null,
    middleNameAr: null,
    lastNameAr: null,
    visaFileNo: null,
    plan: null,
    visaLocation: null,
    medicalCardNumber: null,
    visaType: null,
    isNewEntry: false,
    isResident: null,
    memberInformationClass: false,
    isAdditionOfMember: false,
    inceptionDate: null,
    isActive: null,

    premiumPerPerson: null,
    extraPremium: null,
    maternityPremium: null,
    autoLoadingPerc: null,
    autoLoadingAmt: null,
    uwLoadingPerc: null,
    uwLoadingAmt: null,
    netLoadingPerc: null,
    netLoadingAmt: null,
    discountPerc: null,
    discountAmt: null,
    netPremiumAmt: null,
    showDependentInformation: false,
    basmaFee: 19,
    haadPenalty: 0,
    hcvFee: 18,
    finalPenalty: 0,
    showDubaiRegionFee: false,
    showAbuDhabiRegionFee: false,
    showDOHPenaltyButton: false,
    isDohVerifiedYN: null,
    principalCardNumber: null,
    commissionYN: false,
    uhcgMemberYN: false,
    uhcTransmitId: null,
    altId: null,
    changeOfCategoryHasError: false,
    cocVerifiedYN: null
}
initialState.individualPlansTOB = {
    currentPlanTOB: [], // contains static dropdowns values, benifits
    productName: null,
    planName: null,
}
initialState.benefitStructure = {
    benefitsLeftSide: [], // left side benefits
    selectedPlans: [],
    planDefaultBenefits: [],
    premiumDetails: [],
}
initialState.basicInfoNewEnq = {
    enquiryNo: null,
    enquiryId: 0,
    encryptedEnquiryRefId1: null,
    encryptedEnquiryRefId2: null,
    visaEmirate: null,
    visaType: null,
    salaryBand: null,
    sponsorName: null,
    mobile: null,
    email: null,
    isSponsorMember: false,
    quotationNo: null,
    selectedPlan: {},
    refferalLinkValue: null,//'ChHh12DVUDACUObFaWFfnQ==',
    quoteId: null,

    insuredType: appConstants.INSURED_TYPE_INDIVIDUAL,
    crNo: null,
    tradeLicNo: null,
    tradeLicExp: null,

    planType: null,
    // quoteStage: null,
    // quoteStatus: null,
    isRefertoUW: false,
    planId: null,
    productId: null,
    isPolicyIssued: false,
    isSponsorMemberN: false,
    mafIsCompleted: false,
    isPaymentProcessed: false,
    isCustomerConfirmed: false,
    quoteUtmSource: "",
}
initialState.membersBasePremiumRates = []

initialState.memberBasicInfo = {
    memberList: [
        {
            srlNo: 1,
            memberFullName: null,
            memberDateOfBirth: null,
            relation: null,
            memberGender: null,
            memberMaritalStatus: null,
            memberVisaEmirate: null,
            memberVisaType: null,
            memberEntryDate: null,
            memberHeight: null,
            memberWeight: null,
            isChecked: false,
            memberId: null,
            bmi: null,
            visaFileNumber: null

        }
    ],
    filteredMemberList: [
        {
            srlNo: 1,
            memberFullName: null,
            memberDateOfBirth: null,
            relation: null,
            memberGender: null,
            memberMaritalStatus: null,
            memberVisaEmirate: null,
            memberVisaType: null,
            memberEntryDate: null,
            memberHeight: null,
            memberWeight: null,
            isChecked: false,
            memberId: null,
            bmi: null,
            visaFileNumber: null
        }
    ],
    membersBasePremiumRates: [],
    showPlans: false,
    enquiryId: null,
    encryptedEnquiryRefId1: null,
    encryptedEnquiryRefId2: null,
    enquiryNo: null
}
initialState.masters = {
    statusMasters: [
        { minorCode: 0, statusName: null, moduleType: 0 }
    ],
    businessTypeMaster: [
        { domainValue: 0, domainValueName: null }
    ],
    stageMasters: [
        { stageStatusId: 0, stageName: null, majorCode: 0, moduleType: 0 }
    ],
    productMasters: [
        { productId: 0, productName: null, productCode: null }
    ],
    agentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    allAgentMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    agentSearchMasters: [
        { agentId: 0, agentCode: null, agentName: null }
    ],
    planMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ],
    searchPlanMasters: [
        { planId: 0, planName: null, planCode: null, networkId: null }
    ],
    branchMasters: [
        { brCode: 0, brName: null }
    ],
    visaEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    documentTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    insuredVisaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    entityTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    maritalStatusMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    nationalityMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salutationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    collectionPointMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    typeMaster: [
        { id: 1, name: "Type-1" },
        { id: 2, name: "Type-2", }
    ],
    relationMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    salaryBandMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    idTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    dhaMemberTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    workEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    residentEmirateMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    workLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    residentLocationMasters: [
        { cityId: 0, cityName: null }
    ],
    vatTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    chargesTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    transactionTypeMasters: [
        { domainValue: 1, domainValueName: "Convert Quotation to Endorsement" },
        { domainValue: 2, domainValueName: "Convert Quotation to Policy" },
        { domainValue: 3, domainValueName: "Revision Required" },
        { domainValue: 4, domainValueName: "Print Quotation Summary" },
        { domainValue: 5, domainValueName: "Refer to Underwriter" },
    ],
    principalMasters: [
        { principalId: 0, principalName: null }

    ],
    applyTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    visaTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    regionMasters: [
        { regionId: 0, regionName: null, emirateId: 0, emirateName: null, }
    ],
    promoCodeMasters: [
        { promoId: 0, promoName: null }
    ],
    paymentModeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    portalPlanTypeMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    memberVisaType: [
        { domainValue: 0, domainValueName: null }
    ],
    networkMaster: [
        { domainValue: 0, domainValueName: null }
    ],
    portalPlanTypeMastersFilterd: [
        { domainValue: 0, domainValueName: null }
    ],
    professionMasters: [
        { domainValue: 0, domainValueName: null }
    ],
    visaLocationMasters: [
        { cityId: 0, cityName: null }
    ]
}
initialState.indicativeQuote = {
    insuredInfo: {
        visaEmirate: null,
        visaType: null,
        planType: null,
        firstName: null,
        middleName: null,
        lastName: null,
        dateOfBirth: null,
        gender: null,
        maritalStatus: null,
        mobile: null,
        email: null,
        singleMemberPolicyYN: null,
    },
    memberList: [
        {
            srlNo: 1,
            memberFirstName: null,
            memberLastName: null,
            memberDateOfBirth: null,
            relation: null,
            memberGender: null,
            memberMaritalStatus: null,
            memberHeight: null,
            memberWeight: null,
            isChecked: false,
            memberId: null,
            bmi: null,
        }
    ],
    filteredMemberList: [
        {
            srlNo: 1,
            memberFirstName: null,
            memberLastName: null,
            memberDateOfBirth: null,
            relation: null,
            memberGender: null,
            memberMaritalStatus: null,
            memberHeight: null,
            memberWeight: null,
            isChecked: false,
            memberId: null,
            bmi: null,
        }
    ],
    membersBasePremiumRates: [],
    showPlans: false
}
initialState.productSelection = {
    plansList: [],
    visaEmirate: null,
    planType: null,
    networkType: null
}
initialState.medicalApplicationForm = {
    currentMemberId: null,
    currentMemberName: null,
    currentMemberMaritalStatus: null,
    currentMemberGender: null,
    currentMemberMafReferral: null,
    currentMemberMafStatus: null,
    mafQuestions: [],
    mafQuestionsOriginal: [],
    currentMemberMafDetails: [],
    showFullQuestionaire: false,
    showShortQuestionaire: false,
    referralStatus: [],
    mafStatus: [],
    collapseShortQuestionaireClass: "collapse show",
    collapseFullQuestionaireClass: "collapse show",
    mafAnswers: [
        //{itemId:123131, memberIdList:[1,2,4]}, sample
        //{itemId:123131, memberIdList:[1,2,4]},
    ],
    mafDateAnswers: [
        //{memberId:1, date: ""},{memberId:2, date: ""},{memberId:4, date: ""}], sample
        //{memberId:1, date: ""},{memberId:2, date: ""},{memberId:4, date: ""}],
    ],
    isDateSelectedYn: null,
    saveAttempted: false,
}
initialState.quoteDocuments = {
    documentList: [],
    mandatoryDocumentMaster: [],
    documentMaster: [],
    hasCheckedBoxInDocuments: false,
    showDocumentsTab: false,
    isMemberDocumentsSaved: false
}
initialState.memberDocuments = {
    documentList: [],
    mandatoryDocumentMaster: [],
    documentMaster: [],
    isMemberDocument: false,
    hasCheckedBoxInDocuments: false
}
// initialState.quoteMembersList = []
initialState.quoteMembers = {
    quoteMembersList: [],
    currentQuoteMember: {
        salutation: null,
        firstName: null,
        middleName: null,
        lastName: null,
        emiratesId: null,
        memberDateOfBirth: null,
        nationality: null,
        memberGender: null,
        memberMaritalStatus: null,
        relation: null,
        passPortNo: null,
        memberVisaType: null,
        // entityId: null,
        salaryBand: null,
        address: null,
        poBox: null,
        uIDNumber: null,
        visaFileNumber: null,
        memberType: null,
        birthCertificateNumber: null,
        memberEntryDate: null,
        previousInsuranceCompany: null,
        previousInsuranceNumber: null,
        previousInsuranceExpiryDt: null,
        memberId: null,
        isFirstPolicy: false,
        workEmirate: null,
        workLocation: null,
        residentEmirate: null,
        residentLocation: null,
        cocRefNo: null,
        isSalaryCommissionBased: false,
        visaEmirate: null,
        profession: null,
        salary: null,
        visaLocation: null,
        idType: null,
    }

}
initialState.premiumSummary = {
    plan: null,
    premium: null,
    documentFee: null,
    basmaFee: null,
    hcvFee: null,
    haadPenalty: null,
    commission: null,
    vat: null,
    netToPay: null,
    memberPremium: [],
    planName: null,
    promoCodeAvailable: null,
    agreeTerms: null,
    documentId: null,
    transDocId: null,
    icpFee: null,
    planType: null,
    basePremium: null,

}
initialState.customerInformation = {
    insuredId: null,
    insuredType: null,
    emiratesId: null,
    mobile: null,
    salutation: null,
    firstName: null,
    middleName: null,
    lastName: null,
    gender: null,
    maritalSatus: null,
    dateofBirth: null,
    age: null,
    nationality: null,
    email: null,
    policyInsuredType: null,
    policyPolicyType: null,
    companyCRNumber: null,
    policysalutation: null,
    fullName: null,
    tradeLicenseNo: null,
    tradeLicenseExpiryDate: null,
    policyEmail: null,
    entityType: null,
    entityId: null,
    isInsuredTypeIndividual: true,
    companyMobile: null,
    masterValues: [],
    insuredCodes: [],
    nameSearch: null,
    companyMobile: null,
    showAddnewSection: false,
    customerId: null,
    customerInPolicyYN: 'N',
    salaryBandTypeId: null,
    address: null,
    poBox: null,
}


export default function miCustomerSharedReducer(state = initialState, action) {
    switch (action.type) {
        /* Permission  Starts*/
        case types.SHOW_MEDICAL_QUOTE:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    showMedicalQuote: true,
                    showService: false
                }
            }

        case types.SHOW_MEDICAL_SERVICES:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    showMedicalQuote: false,
                    showService: true
                }
            }

        case types.GET_MI_CUSTOMER_MASTERS:
            return {
                ...state,
                masters: {
                    ...state.masters,
                    visaEmirateMasters: action.result.visaEmirate,
                    insuredVisaTypeMasters: action.result.visaType,
                    genderMasters: action.result.gender,
                    maritalStatusMasters: action.result.maritalStatus,
                    relationMasters: action.result.relation,
                    portalPlanTypeMasters: action.result.portalPlanTypeMaster,
                    portalPlanTypeMastersFilterd: action.result.portalPlanTypeMaster,
                    paymentModeMasters: action.result.paymentModeMasters,
                    memberVisaType: action.result.memberVisaType,
                    salutationMasters: action.result.salutationMasters,
                    nationalityMaster: action.result.nationalityMaster,
                    salaryBandMasters: action.result.salaryBandMasters,
                    sponsorTypeMasters: action.result.sponsorTypeMasters,
                    entityTypeMasters: action.result.entityTypeMasters,
                    memberTypeMaster: action.result.memberTypeMaster,
                    regionMaster: action.result.regionMaster,
                    insuredTypeMasters: action.result.insuredTypeMasters,
                    idTypeMasters: action.result.idTypeMasters,
                    //  networkMaster: action.result.networkMaster,
                    professionMasters: action.result.professionMasters
                }
            }
        case types.SAVE_MI_CUSTOMER_NEW_ENQUIRY:


            return {
                ...state,
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,
                    enquiryNo: action.payload.enquiryNo,
                    enquiryId: action.payload.enquiryId,
                    encryptedEnquiryRefId1: action.payload.encryptedEnquiryRefId1,
                    encryptedEnquiryRefId2: action.payload.encryptedEnquiryRefId2,
                }
            }
        case types.UPDATE_BASIC_QUOTE_PARAMS:
            return {
                ...state,
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,
                    [action.payload.name]: action.payload.value
                }

            }


        case types.HANDLE_NEXT_STEP:
            return {
                ...state,
                activeStep: action.payload

            }

        case types.TOGGLE_CONFRIM_POPUP:
            return {
                ...state,
                confirmPopup: {
                    ...state.confirmPopup,
                    showConfirmPopup: action.payload.showConfirmPopup,
                    message: action.payload.message,
                    showYes: action.payload.isConfirm,
                    showNo: action.payload.isConfirm,
                    showOk: action.payload.isInfo,
                    isComp: action.payload.isComp,
                    resolve: action.payload.resolve,
                    title: action.payload.title,

                }

            }
        case types.CONFIRM_YES:
            if (state.confirmPopup.resolve) {
                state.confirmPopup.resolve(true); // Resolving with "true" when confirmed
            }
            return {
                ...state,
                confirmPopup: {
                    ...state.confirmPopup,
                    showConfirmPopup: false,
                    message: null,
                    resolve: null,
                    showYes: false,
                    showNo: false,
                    showOk: false,
                }

            }
        case types.CONFIRM_NO:
            if (state.confirmPopup.resolve) {
                state.confirmPopup.resolve(false); // Resolving with "true" when confirmed
            }  // Resolve the promise with "false"
            return {
                ...state,
                confirmPopup: {
                    ...state.confirmPopup,
                    showConfirmPopup: false,
                    message: null,
                    resolve: null,
                    showYes: false,
                    showNo: false,
                    showOk: false
                }

            }

        case types.ADD_SPONSOR_TO_QUOTE: {
            let memberList = [];
            let insuredInfo = state.basicInfoNewEnq;
            console.log('ADD_SPONSOR_TO_QUOTE', state.basicInfoNewEnq);

            memberList.push(
                {
                    srlNo: 1,
                    memberFullName: insuredInfo.sponsorName,
                    memberDateOfBirth: insuredInfo.dateOfBirth,
                    relation: appConstants.RELATION_PRINCIPAL_ID,
                    memberGender: insuredInfo.gender,
                    memberMaritalStatus: insuredInfo.maritalStatus,
                    memberVisaEmirate: null,
                    memberVisaType: null,
                    memberEntryDate: null,
                    memberHeight: null,
                    memberWeight: null,
                    isChecked: null,
                    memberId: null,
                    bmi: null,
                }
            )
            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    filteredMemberList: memberList,
                    memberList: memberList
                }
            }
        }


        case types.UPDATE_BASIC_MEMBER_INFO_LIST: {
            console.log("[action.payload.name]: action.payload.value", [action.payload.name], action.payload.value, action.payload.id)
            let slNo = parseFloat(action.payload.id);
            let memberList = [...state.memberBasicInfo.memberList];
            const updatedMemberList = memberList.map((m) => {
                if (m.srlNo == slNo) {
                    return {
                        ...m,
                        [action.payload.name]: action.payload.value
                    };
                }
                return m;
            });
            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    memberList: updatedMemberList,
                    filteredMemberList: updatedMemberList
                }
            }

        }

        case types.UPDATE_BASIC_MEMBER_INFO:
            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    [action.payload.name]: action.payload.value
                }

            }

        case types.ADD_MEMBER: {
            let memberList = [...state.memberBasicInfo.memberList];
            // let filteredMemberList = state.memberBasicInfo.filteredMemberList;
            var srlNos = memberList.map(x => x.srlNo)
            var maxId = Math.max.apply(Math, srlNos)
            maxId == -Infinity ? maxId = 0 : maxId = maxId
            memberList.push(
                {
                    srlNo: maxId + 1,
                    memberFullName: null,
                    memberDateOfBirth: null,
                    relation: null,
                    memberGender: null,
                    memberMaritalStatus: null,
                    memberVisaEmirate: null,
                    memberVisaType: null,
                    memberEntryDate: null,
                    memberHeight: null,
                    memberWeight: null,
                    isChecked: null,
                    memberId: null,
                    bmi: null,
                }
            )
            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    filteredMemberList: memberList,
                    memberList: memberList
                }
            }
        }
        case types.DELETE_MEMBER: {
            console.log('DELETE_MEMBER', action.payload);

            let memberList = [...state.memberBasicInfo.memberList];
            let spliceMemberList = []
            var updatedMemberList = memberList.filter(p => p.srlNo != action.payload)

            for (let i = 0; i < updatedMemberList.length; i++) {
                let Arr = {
                    ...updatedMemberList[i],
                    srlNo: i + 1
                }
                spliceMemberList.push(Arr)
            }

            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    filteredMemberList: spliceMemberList,
                    memberList: spliceMemberList
                }
            }
        }

        case types.DELETE_ALL_MEMBERS: {
            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    filteredMemberList: [{
                        srlNo: 1,
                        memberFirstName: null,
                        memberLastName: null,
                        memberDateOfBirth: null,
                        relation: null,
                        memberGender: null,
                        memberMaritalStatus: null,
                        memberVisaEmirate: null,
                        memberVisaType: null,
                        memberEntryDate: null,
                        memberHeight: null,
                        memberWeight: null,
                        isChecked: null,
                        memberId: null,
                    }],
                    memberList: [{
                        srlNo: 1,
                        memberFirstName: null,
                        memberLastName: null,
                        memberDateOfBirth: null,
                        relation: null,
                        memberGender: null,
                        memberMaritalStatus: null,
                        memberVisaEmirate: null,
                        memberVisaType: null,
                        memberEntryDate: null,
                        memberHeight: null,
                        memberWeight: null,
                        isChecked: null,
                        memberId: null,
                        bmi: null,
                    }]
                }
            }
        }


        case types.RESET_PRODUCT_SELCTION:
            return {
                ...state,
                productSelection: {
                    ...state.productSelection,
                    plansList: []
                }
            }
        case types.UPDATE_PRODUCT_SELECTION_PARAMS:
            var updatedPlansList = state.productSelection.plansList.map(plan => ({
                ...plan,
                isChecked: false
            }));
            return {
                ...state,
                productSelection: {
                    ...state.productSelection,
                    [action.payload.name]: action.payload.value,
                    plansList: updatedPlansList
                }
            }

        case types.UPDATE_PRODUCT_TYPE:

            return {
                ...state,
                productSelection: {
                    ...state.productSelection,
                    [action.payload.name]: action.payload.value,
                }
            }


        case types.GET_PLANS_BY_VISA_EMIRATES_END:
            var isSelected = action.result.find(p => p?.isChecked == true)
            if (isSelected) {
                return {
                    ...state,
                    productSelection: {
                        ...state.productSelection,
                        plansList: action.result,
                    },
                    basicInfoNewEnq: {
                        ...state.basicInfoNewEnq,

                        selectedPlan: isSelected
                    },
                    planType: isSelected.portalPlanTypeId
                }
            }
            else {
                return {
                    ...state,
                    productSelection: {
                        ...state.productSelection,
                        plansList: action.result,
                    }
                }
            }

        case types.GET_MEMBER_BASE_PLAN_END:
            return {
                ...state,
                membersBasePremiumRates: [
                    ...action.result,
                ]
            }
        case types.TOGGLE_MEMBER_BASE_PREM_MODAL:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    memberBasePremModal: action.result
                }
            }
        case types.TOGGLE_PLAN_TOB_MODAL:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    planTobModal: action.result
                }
            }
        case types.GET_INDIVIDUAL_PLANS_TOB_END:
            return {
                ...state,
                individualPlansTOB: {
                    ...state.individualPlansTOB,
                    currentPlanTOB: action.result,
                }
            }
        case types.UPDATE_PLAN_SELECTION:

            var planList = state.productSelection.plansList;
            console.log('UPDATE_PLAN_SELECTION', planList, action.payload.id, action.payload.productId);

            //  planList.forEach(p => p.isChecked == false);
            const updatedList = planList.map((plan) =>
                // plan.planId == action.payload.id ? { ...plan, isChecked: !plan.isChecked } : plan
                plan.planId == action.payload.id && plan.productId == action.payload.productId ? { ...plan, isChecked: !plan.isChecked } : { ...plan }
            );

            var plan = updatedList.find(w => w.planId == action.payload.id && w.isChecked)
            console.log(action.payload.id);

            return {
                ...state,
                productSelection: {
                    ...state.productSelection,
                    plansList: updatedList,
                },
                payment: {
                    ...state.payment,
                    netToPay: plan?.basePremium
                },
                planType: plan?.portalPlanTypeId
            }

        case types.GET_MAF_QUESTIONS_END: {
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: action.payload,
                    mafQuestionsOriginal: action.payload
                }
            }
        }
        case types.GET_MAF_ANSWERS_END: {
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafAnswers: action.payload?.mafAnswers,
                    mafDateAnswers: action.payload?.mafDateAnswers?.map(q => {
                        return {
                            ...q,
                            date: appUtility.formatDate(q?.date)
                        };
                    }),
                    // mafDateAnswers: action.payload?.mafDateAnswers,
                    isDateSelectedYn: action.payload?.isDateSelectedYn,
                }
            }
        }


        case types.UPDATE_MEDICAL_FORM_PARAMS: {
            let updatedMafQuestions = state.medicalApplicationForm.mafQuestions;
            let filterMafQuestions = state.medicalApplicationForm.mafQuestions;
            let subQuestionDetails = filterMafQuestions.filter(p => p.itemId == action.payload.name);
            let updateValues = {};
            let subSubQuestionDetails = [];
            // Check if the current question is a sub-item
            updateValues = updatedMafQuestions.map(q => {
                if (q.itemId == action.payload.name) {
                    return {
                        ...q,
                        isApplicable: action.payload.value
                    };
                }
                return q;
            });
            if (action.payload.value == "N" && subQuestionDetails[0].sectionId == 1) {
                if (subQuestionDetails[0].isSubItem == "N") {
                    updateValues = updateValues.map(q => {
                        if (q.parentId == subQuestionDetails[0].itemId) {
                            return {
                                ...q,
                                isApplicable: null,
                                isRequired: false
                            };
                        }
                        return q;
                    });
                    subQuestionDetails = updateValues.filter(p => p.parentId == subQuestionDetails[0].itemId);
                }
                if (subQuestionDetails.length != 0) {
                    // If the value is 'N', set all sub-items' isApplicable to null and isRequired to false
                    if (action.payload.value == "N") {
                        /* updateValues = updateValues.map(q => {
                             let filteredSubQuestions = subQuestionDetails.filter(p => p.itemId == q.itemId)
                             if (filteredSubQuestions.length != 0) {
                                 subSubQuestionDetails = updateValues.filter(p => p.parentId == q.itemId)
                                 return {
                                     ...q,
                                     isApplicable: null,
                                     isRequired: false
                                 };
                             }
 
                             return q;
                         });*/
                        subQuestionDetails.map(x => {
                            subSubQuestionDetails = updateValues.filter(p => p.parentId == x.itemId)
                            updateValues = updateValues.map(q => {
                                let filteredSubSubQuestions = subSubQuestionDetails.filter(p => p.itemId == q.itemId)
                                if (filteredSubSubQuestions.length != 0) {
                                    return {
                                        ...q,
                                        isApplicable: null,
                                        isRequired: false
                                    };
                                }
                                return q;
                            });
                        });
                    }

                }

            }
            // If the value is 'Y', set all sub-items' isRequired to true
            else if (action.payload.value == "Y" && subQuestionDetails[0].sectionId == 1) {
                if (subQuestionDetails[0].isSubItem == "N") {
                    subQuestionDetails = updateValues.filter(p => p.parentId == subQuestionDetails[0].itemId);

                }
                subQuestionDetails.map(x => {
                    subSubQuestionDetails = updateValues.filter(p => p.parentId == x.itemId)
                    updateValues = updateValues.map(q => {
                        let filteredSubSubQuestions = subSubQuestionDetails.filter(p => p.itemId == q.itemId)
                        if (filteredSubSubQuestions.length != 0) {
                            return {
                                ...q,
                                isRequired: true
                            };
                        }
                        return q;
                    });
                });
            }
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: updateValues
                }
            }
        }
        case types.UPDATE_SUB_MEDICAL_FORM_PARAMS: {
            // Filter out the sub-question based on the action payload name
            const subQuestionDetails = state.medicalApplicationForm.mafQuestions.filter(
                (p) => p.itemId == action.payload.name
            );
            // Update the mafQuestions with the updated values
            const updatedMafQuestions = state.medicalApplicationForm.mafQuestions.map((question) => {
                if (question.parentId == subQuestionDetails[0].parentId && question.itemId == action.payload.name) {
                    // Set the isApplicable and isRequired values for the sub-question
                    return {
                        ...question,
                        isApplicable: action.payload.value,
                        isRequired: true,
                    };
                }
                else if (question.parentId == subQuestionDetails[0].parentId) {
                    // Set the isApplicable and isRequired values for the sub-question's parent
                    return {
                        ...question,
                        isApplicable: null,
                        isRequired: false,
                    };
                }
                // Return the original question if it's not a sub-question or its parent
                return question;
            });
            // Return the updated state
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: updatedMafQuestions,
                },
            };
        }
        case types.UPDATE_MEDICAL_FORM_REMARKS: {
            let updatedMafQuestions = state.medicalApplicationForm.mafQuestions;
            for (let j = 0; j < updatedMafQuestions.length; j++) {
                if (updatedMafQuestions[j].itemId == action.payload.id) {
                    /*update remarks */
                    updatedMafQuestions[j].remarks = action.payload.value
                }
            }
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: updatedMafQuestions
                }
            }
        }
        case types.UPDATE_MEDICAL_FORM_REMARKS_DATE: {
            let updatedMafQuestions = state.medicalApplicationForm.mafQuestions;
            for (let j = 0; j < updatedMafQuestions.length; j++) {
                if (updatedMafQuestions[j].itemId == action.payload.id) {
                    /*update remarks */
                    updatedMafQuestions[j].value = action.payload.value
                }
            }
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: updatedMafQuestions
                }
            }
        }
        case types.UPDATE_MEDICAL_FORM_LIST: {
            let updatedMafQuestions = state.medicalApplicationForm.mafQuestions;
            for (let j = 0; j < updatedMafQuestions.length; j++) {
                if (updatedMafQuestions[j].itemId == action.payload.itemId) {
                    /*update List Value */
                    for (let i = 0; i < updatedMafQuestions[j].attributes.length; i++) {
                        if (updatedMafQuestions[j].attributes[i].attributeId == action.payload.id) {
                            for (let k = 0; k < updatedMafQuestions[j].attributes[i].itemValue.length; k++) {
                                if (updatedMafQuestions[j].attributes[i].itemValue[k].value == action.payload.value) {
                                    updatedMafQuestions[j].attributes[i].itemValue[k].valueIsChosen = "Y"
                                }
                                else {
                                    updatedMafQuestions[j].attributes[i].itemValue[k].valueIsChosen = "N"
                                }
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    mafQuestions: updatedMafQuestions
                }
            }
        }
        case types.UPDATE_MAF_INFO: {
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        case types.SAVE_BASIC_MEMBER_INFO: {
            const lst = action?.payload?.memberList || [];

            const newList = lst
                .map(p => ({
                    ...p,
                    memberDateOfBirth: appUtility.formatDate(p?.memberDateOfBirth),
                    memberEntryDate: p?.memberEntryDate ? appUtility.formatDate(p?.memberEntryDate) : null
                }));
            // .sort((a, b) => a?.memberId - b?.memberId); // Now sorting a fully cloned array


            return {
                ...state,
                memberBasicInfo: {
                    ...state.memberBasicInfo,
                    filteredMemberList: newList,
                    memberList: newList
                }
            }
        }
        case types.SAVE_PLAN_DETAILS: {
            return {
                ...state,
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,
                    quotationNo: action?.payload?.quoteNumber,
                    selectedPlan: state?.productSelection?.plansList?.find(p => p?.isChecked == true)
                },

            }
        }
        case types.SET_PLAN_ID_FROM_QUOTE_SEARCH: {
            return {
                ...state,
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,

                    selectedPlan: state?.productSelection?.plansList?.find(p => p?.isChecked == true)
                }
            }
        }

        case types.UPDATE_PAYMENT_TRANSACTION_PARAMS: {
            return {
                ...state,
                payment: {
                    ...state?.payment,
                    [action.payload.name]: action?.payload?.value

                }
            }
        }
        case types.GET_QUOTE_MEMBERS: {
            // var newList = [...action?.payload?.memberList]?.map(p => ({ ...p, memberDateOfBirth: appUtility.formatDate(p?.memberDateOfBirth), memberEntryDate: p?.memberEntryDate ? appUtility.formatDate(p?.memberEntryDate) : null }))

            const lst = action?.payload?.memberList || [];

            const newList = lst
                .map(p => ({
                    ...p,
                    memberDateOfBirth: appUtility.formatDate(p?.memberDateOfBirth),
                    memberEntryDate: p?.memberEntryDate ? appUtility.formatDate(p?.memberEntryDate) : null
                }));
            // .sort((a, b) => a?.memberId - b?.memberId); // Now sorting a fully cloned array


            return {
                ...state,
                memberBasicInfo: {
                    ...state?.memberBasicInfo,
                    memberList: newList,
                    filteredMemberList: newList

                }
            }
        }
        case types.GET_PAYMENT_INFORMATION_END_MICUSTOMER: {
            return {
                ...state,
                paymentInformation: {
                    ...state.paymentInformation,
                    customerName: action.payload.customerName,
                    customerEmail: action.payload.customerEmail,
                    customerPhone: action.payload.customerPhone,
                    amount: action.payload.amount,
                    description: action.payload.referenceText,
                    referenceId: action.payload.referenceId,
                    encryptedEnquiryRefId1: action.payload.encryptedEnquiryRefId1,
                    encryptedEnquiryRefId2: action.payload.encryptedEnquiryRefId2,
                    policyNo: action.payload.policyNumber
                }
            }
        }
        case types.CHECK_SHORT_QUESTIONS_MAF_STATUS_MICUSTOMER: {
            let ShortQuestionsCheckedYes = action.payload.data.length == 0 ? false : true
            //let memberList = state?.memberBasicInfo?.memberList   
            let memberList = [...state.memberBasicInfo.memberList];
            let mafAnswers = [...state?.medicalApplicationForm?.mafAnswers]
            var referralStatus = []
            var mafStatus = []
            memberList.forEach(member => {
                var refcheck = mafAnswers?.find(x => x?.memberIdList?.includes(member?.memberId))

                let MemberReferral = (/* data.length == 0 ||  */(refcheck == null)) ? "Clean" : "Referral"
                if (/* isRefferalMember[0].isMemberRefferal ||  */member?.bmi >= 36) {
                    MemberReferral = "Referral"
                }
                let mafMemberStatus = MemberReferral == "Clean" ? "Complete" : "Incomplete"
                if (state?.basicInfoNewEnq?.selectedPlan?.productId == constants.PRODUCT_ASASI_EMPLOYEE && MemberReferral == "Referral" /* && state.medicalApplicationForm.mafQuestions.filter((e) => e.sectionId === constants.MAF_FULL_QUESTIONAIRE_ID && e.isSubItem === constants.MAF_IS_SUB_ITEM_FLAG_N) == 0 */) {
                    mafMemberStatus = "Complete"
                }
                if (mafMemberStatus == "Incomplete") {
                    ShortQuestionsCheckedYes = true;
                }
                referralStatus.push({ memberId: member?.memberId, MemberReferral }); //MemberReferral
                mafStatus.push({ memberId: member?.memberId, mafMemberStatus }); //mafMemberStatus
            }
            )
            //------------------------------------------------------------------------------------------------------------
            // let isRefferalMember = state.memberDetails.memberFilteredDetails.result.filter(p => p.memberId == action.payload.memberId)
            // if (isRefferalMember[0].isMemberRefferal || isRefferalMember[0].bmi >= 36) {
            //     MemberReferral = "Referral"
            // }
            // let mafMemberStatus = MemberReferral == "Clean" ? "Complete" : "Incomplete"
            // if (state.quoteInformation.product == constants.PRODUCT_ASASI_EMPLOYEE && MemberReferral == "Referral" && state.medicalApplicationForm.mafQuestions.filter((e) => e.sectionId === constants.MAF_FULL_QUESTIONAIRE_ID && e.isSubItem === constants.MAF_IS_SUB_ITEM_FLAG_N) == 0) {
            //     mafMemberStatus = "Complete"
            // }
            // if (mafMemberStatus == "Incomplete") {
            //     ShortQuestionsCheckedYes = true;
            // }
            return {
                ...state,
                medicalApplicationForm: {
                    ...state.medicalApplicationForm,
                    // showFullQuestionaire: ShortQuestionsCheckedYes,
                    referralStatus: referralStatus,
                    mafStatus: mafStatus
                }
            }

        }

        case types.GET_PLAN_COMPARE_STRUCUTRE_END:
            return {
                ...state,
                benefitStructure: {
                    ...state.benefitStructure,
                    planDefaultBenefits: action.result.planDefaultBenefits,
                    benefitsLeftSide: action.result.benefitLayout,
                    selectedPlans: action.result.plansDetails,
                    premiumDetails: action.result.premiumDetails,
                }
            }


        case types.TOGGLE_PLAN_COMPARE:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    planCompare: action.result
                }
            }
        case types.TOGGLE_SEARCH:
            console.log('TOGGLE_SEARCH', action.result);

            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    showSearch: action.payload
                }
            }
        case types.QUOTE_SEARCH_RESULT:
            console.log('QUOTE_SEARCH_RESULT', action.payload);

            return {
                ...state,
                quoteSearchResult: action.payload,
                isFromSearch: true,
            }
        case types.UPDATE_QUOTE_SEARCH_PARAMS:


            return {
                ...state,
                quoteSearchParams: {
                    ...state?.quoteSearchParams,
                    [action.payload.name]: action?.payload?.value

                }
            }

        case types.CHECK_DOCUMENT_TAB_TYPE: {
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    isMemberDocument: action.payload === 'member',
                }
            };
        }
        case types.ADD_NEW_DOCUMENT: {
            if (state.memberDocuments.isMemberDocument && state.memberDocuments.documentMaster.length > 0) {
                let documentCount = state.memberDocuments.documentList.length;
                return {
                    ...state,
                    memberDocuments: {
                        ...state.memberDocuments,
                        documentList: [
                            ...state.memberDocuments.documentList,
                            {
                                srlNo: documentCount + 1,
                                docType: '',
                                refNo: null,
                                description: null,
                                fileType: null,
                                fileInput: "",
                                isChecked: false,
                                isMandatory: false
                            }
                        ]
                    }
                }
            }
        }

        case types.CLEAR_DOCUMENT_LIST: {
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    documentList: [],
                    hasCheckedBoxInDocuments: false
                },
                quoteDocuments: {
                    ...state.quoteDocuments,
                    documentList: [],
                    mandatoryDocumentMaster: [],
                    // documentMaster: action.payload
                }
            };
        }

        // case types.UPDATE_DOCUMENT_CHECKBOX_PARAMS: {
        //     // Determine which list of documents to update
        //     const documentsList = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'quoteDocuments';
        //     // Find the index of the document to update
        //     const documentIndex = state[documentsList].documentList.findIndex(d => d.srlNo == action.payload.id);
        //     // Update the isChecked property of the document
        //     const updatedDocumentList = [...state[documentsList].documentList];
        //     updatedDocumentList[documentIndex].isChecked = action.payload.checked;
        //     // Check if there are any checked boxes in the updated document list
        //     const hasCheckedBoxInDocuments = updatedDocumentList.filter(p => p.isChecked == true).length > 0;
        //     // Return the updated state
        //     return {
        //         ...state,
        //         [documentsList]: {
        //             ...state[documentsList],
        //             documentList: updatedDocumentList,
        //             hasCheckedBoxInDocuments
        //         }
        //     }
        // }

        // case types.GET_MEMBER_DOCUMENT_MASTERS_END: {
        //     var mandatoryDocs = action.payload.filter(p => p.isMandatory);
        //     var optionalDocs = action.payload.filter(p => !p.isMandatory);
        //     return {
        //         ...state,
        //         memberDocuments: {
        //             ...state.memberDocuments,
        //             mandatoryDocumentMaster: mandatoryDocs,
        //             documentMaster: action.payload
        //         }
        //     }
        // }
        case types.GET_MEMBER_DOCUMENT_LIST_END: {
            return {
                ...state,
                memberDocuments: {
                    ...state.memberDocuments,
                    documentList: action.payload
                }
            }
        }
        case types.UPDATE_DOCUMENT_PARAMS_END: {
            if (action.payload.isMember) {
                return {
                    ...state,
                    memberDocuments: {
                        ...state.memberDocuments,
                        documentList: action.payload.updatedDocParams
                    }
                }
            }
            else {
                return {
                    ...state,
                    quoteDocuments: {
                        ...state.quoteDocuments,
                        documentList: action.payload.updatedDocParams
                    }
                }
            }

        }

        // case types.UPDATE_FILE_CHANGE_END: {
        //     return {
        //         ...state,
        //         quoteDocuments: {
        //             ...state.quoteDocuments,
        //             documentList: action.payload.updatedFile
        //         }
        //     }
        // }

        case types.UPDATE_FILE_CHANGE_END: {
            const { updatedFile } = action.payload;

            return {
                ...state,
                quoteDocuments: {
                    ...state.quoteDocuments,
                    documentList: state.quoteDocuments.documentList.map((doc) => {
                        if (doc.docTypeId === updatedFile.docTypeId) {
                            return {
                                ...doc,
                                fileInput: updatedFile.fileInput,
                                fileName: updatedFile.fileName,
                                fileType: updatedFile.fileType,
                                uploadedDate: updatedFile.uploadedDate,
                            };
                        }
                        return doc;
                    }),
                },
            };
        }


        // case types.UPDATE_HAS_CHECKBOX_IN_DOCUMENTS:
        //     const documentsList = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'quoteDocuments';
        //     return {
        //         ...state,
        //         [documentsList]: {
        //             ...state[documentsList],
        //             hasCheckedBoxInDocuments: action.data
        //         }
        //     }

        case types.DELETE_DOCUMENT_FROM_GRID:
            const documentListType = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'quoteDocuments';
            var docsNotSelected = state[documentListType].documentList.filter(p => !p.isChecked);
            return {
                ...state,
                [documentListType]: {
                    ...state[documentListType],
                    documentList: docsNotSelected,
                    hasCheckedBoxInDocuments: false
                }
            }
        case types.UPDATE_DOCUMENTS_TABLE_ID: {
            const documentListType = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'quoteDocuments';
            let spliceDocumentInfo = []
            for (let i = 0; i < state[documentListType].documentList.length; i++) {
                let Arr = {
                    ...state[documentListType].documentList[i],
                    srlNo: i + 1
                }
                spliceDocumentInfo.push(Arr)
            }
            console.log(state[documentListType].documentList)
            console.log(spliceDocumentInfo)
            return {
                ...state,
                [documentListType]: {
                    ...state[documentListType],
                    documentList: spliceDocumentInfo
                }
            }
        }

        // case types.UPDATE_QUOTE_CUSTOMER_DOCUMENTS_TABLE_ID: {
        //     // const documentListType = state.memberDocuments.isMemberDocument ? 'memberDocuments' : 'quoteDocuments';
        //     let spliceDocumentInfo = []
        //     for (let i = 0; i < state.quoteDocuments.documentList.length; i++) {
        //         let Arr = {
        //             ...state.quoteDocuments.documentList[i],
        //             srlNo: i + 1
        //         }
        //         spliceDocumentInfo.push(Arr)
        //     }
        //     return {
        //         ...state.quoteDocuments,
        //         documentList: {
        //             ...state.quoteDocuments,
        //             documentList: spliceDocumentInfo
        //         }
        //     }
        // }

        case types.GET_QUOTE_DOCUMENT_MASTERS_END: {
            var mandatoryDocs = action.payload.filter(p => p.isMandatory);
            var optionalDocs = action.payload.filter(p => !p.isMandatory);
            console.log('dddadada', action.payload, mandatoryDocs);

            return {
                ...state,
                quoteDocuments: {
                    // ...state.quoteDocuments,
                    documentList: action.payload,
                    mandatoryDocumentMaster: mandatoryDocs,
                    documentMaster: action.payload
                }
            }
        }
        // case types.GET_QUOTE_DOCUMENT_LIST_END: {
        //     return {
        //         ...state,
        //         quoteDocuments: {
        //             ...state.quoteDocuments,
        //             documentList: action.payload
        //         }
        //     }
        // }
        case types.SHOW_QUOTE_DOCUMENT_TAB: {
            return {
                ...state,
                quoteDocuments: {
                    ...state.quoteDocuments,
                    showDocumentsTab: true
                }
            }
        }
        case types.SHOW_MEMBER_DOCUMENT_TAB: {
            return {
                ...state,
                quoteDocuments: {
                    ...state.quoteDocuments,
                    showDocumentsTab: false,
                    showMemberTab: true,
                    memId: action.payload
                }
            }
        }

        case types.UPDATE_PROSPECT_INFORMATION_PARAMS:
            return {
                ...state,
                prospectInformation: {
                    ...state.prospectInformation,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.UPDATE_MEMBER_INFORMATION_PARAMS:
            return {
                ...state,
                dependentInformation: {
                    ...state.dependentInformation,
                    [action.payload.name]: action.payload.value
                }
            }

        case types.GET_MEMBER_DETAILS_BY_QUOTE_ID:
            console.log('GET_MEMBER_DETAILS_BY_QUOTE_ID', action.payload);
            var newList = [...action?.payload?.memberList]?.map(p => ({
                ...p,
                memberDateOfBirth: appUtility.formatDate(p?.memberDateOfBirth),
            }));
            var prospect = newList.find(w => w.notMember || w.relation == appConstants.RELATION_PRINCIPAL_ID);
            if (!prospect) {
                console.log('No prospect found.');
                return {
                    ...state,
                    prospectInformation: {
                        ...state.prospectInformation,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        memberFullName: null,
                        memberDateOfBirth: null,
                    },
                };
            }
            var splitedText = prospect?.memberFullName?.split(' ');
            var isOne = splitedText?.length == 1;

            return {
                ...state,
                prospectInformation: {
                    ...state.prospectInformation,
                    ...prospect,
                    firstName: prospect.firstName ?? (!isOne ? splitedText[0] : null),
                    middleName: prospect.middleName ?? (!isOne ? splitedText[1] : null),
                    lastName: prospect.lastName ?? (!isOne ? splitedText[2] : null),
                },
            };

        case types.SET_QUOTE_MEMBERS_RESULT:
            return {
                ...state,
                quoteMembers: {
                    ...state.quoteMembers,
                    quoteMembersList: action.payload,
                },
            };
        case types.SET_QUOTE_MEMBER_DOCUMENT:
            const currentMemberr = state.memberBasicInfo?.filteredMemberList.find(
                (member) => member.memberId !== null && member.memberId.toString() === action.payload.toString()
            ) || {};
            return {
                ...state,
                currentDocQuoteMembers: {
                    age: appUtility.formatDate(currentMemberr.memberDateOfBirth)
                },
            };

        case types.SET_CURRENT_QUOTE_MEMBER:
            const currentMember = state.quoteMembers.quoteMembersList.find(
                (member) => member.memberId !== null && member.memberId.toString() === action.payload.toString()
            ) || {};

            console.log('quoteMembersListaaa', state.quoteMembers.quoteMembersList);


            return {
                ...state,
                quoteMembers: {
                    ...state.quoteMembers,
                    currentQuoteMember: {
                        salutation: currentMember.salutation,
                        firstName: currentMember.firstName,
                        middleName: currentMember.middleName,
                        lastName: currentMember.lastName,
                        emiratesId: currentMember.emiratesId,
                        memberDateOfBirth: appUtility.formatDate(currentMember.memberDateOfBirth),
                        nationality: currentMember.nationality,
                        memberGender: currentMember.memberGender,
                        memberMaritalStatus: currentMember.memberMaritalStatus,
                        relation: currentMember.relation,
                        passPortNo: currentMember.passPortNo,
                        memberVisaType: currentMember.memberVisaType,
                        // entityId: currentMember.entityId,
                        salaryBand: currentMember.salaryBand,
                        address: currentMember.address,
                        poBox: currentMember.poBox,
                        uIDNumber: currentMember.uidNumber,
                        visaFileNumber: currentMember.visaFileNumber,
                        memberType: currentMember.memberType,
                        birthCertificateNumber: currentMember.birthCertificateNumber,
                        memberEntryDate: appUtility.formatDate(currentMember.memberEntryDate),
                        previousInsuranceCompany: currentMember.previousInsuranceCompany,
                        previousInsuranceNumber: currentMember.previousInsuranceNumber,
                        previousInsuranceExpiryDt: appUtility.formatDate(currentMember.previousInsuranceExpiryDt),
                        memberId: currentMember.memberId,
                        isFirstPolicy: currentMember.isFirstPolicy,
                        workEmirate: currentMember.workEmirate,
                        workLocation: currentMember.workLocation,
                        residentEmirate: currentMember.residentEmirate,
                        residentLocation: currentMember.residentLocation,
                        cocRefNo: currentMember.cocRefNo,
                        isSalaryCommissionBased: currentMember.isSalaryCommissionBased,
                        visaEmirate: currentMember.visaEmirate,
                        profession: currentMember.profession,
                        salary: currentMember.salary,
                        visaLocation: currentMember.visaLocation,
                        idType: currentMember.idType,
                    }
                },
            };

        case types.SET_CURRENT_QUOTE_MEMBER_TO_NULL:
            return {
                ...state,
                quoteMembers: {
                    ...state.quoteMembers,
                    currentQuoteMember: {
                        salutation: null,
                        firstName: null,
                        middleName: null,
                        lastName: null,
                        emiratesId: null,
                        memberDateOfBirth: null,
                        nationality: null,
                        memberGender: null,
                        memberMaritalStatus: null,
                        relation: null,
                        passPortNo: null,
                        memberVisaType: null,
                        // entityId: null,
                        salaryBand: null,
                        address: null,
                        poBox: null,
                        uIDNumber: null,
                        visaFileNumber: null,
                        memberType: null,
                        birthCertificateNumber: null,
                        memberEntryDate: null,
                        previousInsuranceCompany: null,
                        previousInsuranceNumber: null,
                        previousInsuranceExpiryDt: null,
                        memberId: null,
                        isFirstPolicy: false,
                        workEmirate: null,
                        workLocation: null,
                        residentEmirate: null,
                        residentLocation: null,
                        cocRefNo: null,
                        isSalaryCommissionBased: false,
                        visaEmirate: null,
                        profession: null,
                        salary: null,
                        visaLocation: null,
                        idType: null,
                    }
                },
            };

        case types.UPDATE_CURRENT_MEMBER_INFO_CHANGE: {
            return {
                ...state,
                quoteMembers: {
                    ...state.quoteMembers,
                    currentQuoteMember: {
                        ...state.quoteMembers.currentQuoteMember,
                        [action.payload.name]: action.payload.value
                    }
                }
            }
        }

        case types.SET_QUOTE_INFORMATION:
            return {
                ...state,
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,
                    enquiryNo: action.payload.enqNo,
                    visaEmirate: action.payload.visaEmirate,
                    visaType: action.payload.visaType,
                    salaryBand: action.payload.salaryBand,
                    sponsorName: action.payload.fullName,
                    mobile: action.payload.phoneNo,
                    email: action.payload.email,
                    // isSponsorMember: action.payload,
                    quotationNo: action.payload.quoteNo,
                    // enquiryId: action.payload.quoteNo,
                    isSponsorMember: action.payload.isSponsorMember,
                    quoteId: action.payload.quoteId,
                    encryptedEnquiryRefId1: action.payload.encryptedEnquiryRefId1,
                    encryptedEnquiryRefId2: action.payload.encryptedEnquiryRefId2,
                    planType: action.payload.planType,
                    // quoteStage: action.payload.quoteStage,
                    // quoteStatus: action.payload.quoteStatus,
                    crNo: action.payload.crNo,
                    tradeLicNo: action.payload.tradeLicNo,
                    tradeLicExp: appUtility.formatDate(action.payload.tradeLicExp),
                    insuredType: action.payload.insuredType,
                    isRefertoUW: action.payload.isRefertoUW,
                    planId: action.payload.planId,
                    productId: action.payload.productId,
                    isPolicyIssued: action.payload.isPolicyIssued,
                    mafIsCompleted: action.payload.mafIsCompleted,
                    isPaymentProcessed: action.payload.isPaymentProcessed,
                    isCustomerConfirmed: action.payload.isCustomerConfirmed,

                },
                payment: {
                    ...state.payment,
                    termsCond: action.payload.isTermsConditionsAccepted,
                }
            }

        case types.HANDLE_CONTINUE:

            return {
                ...state,
                // activeStep: 4,
                modalState: {
                    ...state.modalState,
                    showMedicalQuote: true,
                    showService: false,
                },
                payment: {
                    ...state.payment,
                    paymentDone: true
                },
                basicInfoNewEnq: {
                    ...state.basicInfoNewEnq,
                    enquiryId: action.payload,
                    encryptedEnquiryRefId1: null,
                    encryptedEnquiryRefId2: null,

                }

            }
        case types.GET_PREMIUM_SUMMARY_END:
            {
                return {
                    ...state,
                    premiumSummary: {
                        ...state.premiumSummary,
                        plan: action.result.planId,
                        premium: action.result.premium,
                        documentFee: action.result.documentFee,
                        basmaFee: action.result.basmaFee,
                        hcvFee: action.result.hcvFee,
                        haadPenalty: action.result.haadPenalty,
                        commission: null,
                        vat: action.result.vat,
                        netToPay: action.result.netToPay,
                        memberPremium: action.result.memberPremium,
                        planName: action.result.planName,
                        documentId: action.result.documentId,
                        transDocId: action.result.transDocumentId,
                        icpFee: action.result.icpFee,
                        planType: action.result.planType,
                        basePremium: action.result.basePremium,
                    }
                }
            }
        case types.UPDATE_MODAL_STATE:
            return {
                ...state,
                modalState: {
                    ...state.modalState,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.SET_FILTERED_NETWORKS: {
            console.log('SET_FILTERED_NETWORKS', action.payload);

            return {
                ...state,
                masters: {
                    ...state.masters,
                    networkMaster: action?.payload
                },
            };
        }

        case types.RESTORE_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        case types.GET_PLAN_TYPE_BY_NETWORK_ID: {
            var planTypeIds = action.payload;
            var currentState = state.masters.portalPlanTypeMasters;
            if (planTypeIds?.length > 0) {
                return {
                    ...state,
                    masters: {
                        ...state.masters,
                        portalPlanTypeMastersFilterd: currentState.filter(w => planTypeIds.some(item => item === w.domainValue))
                    }
                }
            }
            return {
                ...state,
                masters: {
                    ...state.masters,
                    portalPlanTypeMastersFilterd: currentState
                }
            }

        }

        case types.SAVE_UAE_PASS_USER_INFO: {
            return {
                ...state,
                uaePassUserInfo: {
                    ...state.uaePassUserInfo,
                },
                prospectInformation: {
                    ...state.prospectInformation,
                    quotationNo: null,
                    firstName: action.payload.firstnameEN,
                    lastName: action.payload.lastnameEN,
                    emiratesId: action.payload.idn,
                    gender: action.payload.genderId,
                    nationality: action.payload.nationalityId,
                    mobile: action.payload.mobile,
                    email: action.payload.email,
                    uidNumber: action.payload.uuid,
                    isSaved: false,
                    isUaeFullnameAR: action.payload.isUaeFullnameAR,
                    isUaeGender: action.payload.isUaeGender,
                    isUaeMobile: action.payload.isUaeMobile,
                    isUaeLastNameEN: action.payload.isUaeLastNameEN,
                    isUaeFullnameEN: action.payload.isUaeFullnameEN,
                    isUaeUuid: action.payload.isUaeUuid,
                    isUaeLastnameAR: action.payload.isUaeLastnameAR,
                    isUaeIdn: action.payload.isUaeIdn,
                    isUaeNationalityId: action.payload.isUaeNationalityId,
                    isUaeFirstnameEN: action.payload.isUaeFirstnameEN,
                    isUaeFirstnameAR: action.payload.isUaeFirstnameAR,
                    isUaeEmail: action.payload.isUaeEmail,

                }
            }
        }

        case types.GET_WORK_LOCATION_MASTER_END: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    workLocationMasters: action.result
                }
            }
        }

        case types.GET_RESIDENT_LOCATION_MASTER_END: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    residentLocationMasters: action.result
                }
            }
        }

        case types.SET_QUOTE_MEMBER_DOCS_SAVED_TRUE: {
            return {
                ...state,
                quoteDocuments: {
                    ...state.quoteDocuments,
                    isMemberDocumentsSaved: true
                }
            }
        }

        case types.GET_VISA_LOCATION_MASTER_END: {
            return {
                ...state,
                masters: {
                    ...state.masters,
                    visaLocationMasters: action.result
                }
            }
        }
        case types.SET_PRODUCT_ID: {
            return {
                ...state,
                productId: action.payload
            }
        }
        case types.CLEAR_MEMBER_DOC: {
            return {
                ...state,
                quoteDocuments: {
                    ...state.quoteDocuments,
                    documentList: [],
                    mandatoryDocumentMaster: [],
                    documentMaster: [],
                    showDocumentsTab: false,
                    showMemberTab: false,
                    memId: null,
                    isMemberDocumentsSaved: false,
                    hasCheckedBoxInDocuments: false,
                }
            }
        }
        case types.GET_CUSTOMER_INFORMATION_END_V1:

            return {
                ...state,
                customerInformation: {
                    ...state.customerInformation,
                    insuredType: action.payload.insuredType,
                    emiratesId: action.payload.emiratesId,
                    mobile: action.payload.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.phoneNo,
                    salutation: action.payload.salutation == null ? (action.payload.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL ? appConstants.DOMAIN_SALUTATION_MS_COMPANY : null) : action.payload.salutation,
                    firstName: action.payload.firstNameEN,
                    middleName: action.payload.middleNameEN,
                    lastName: action.payload.lastNameEN,
                    gender: action.payload.gender,
                    maritalSatus: action.payload.maritalStatus,
                    dateofBirth: action.payload.dob == null ? null : appUtility.formatDate(action.payload.dob),
                    nationality: action.payload.nationality,
                    email: action.payload.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.emailId,
                    companyCRNumber: action.payload.companyCRNo,
                    policysalutation: action.payload.salutation,
                    fullName: action.payload.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL ? action.payload.fulNameEN : "",
                    tradeLicenseNo: action.payload.tradeLicenseNo,
                    tradeLicenseExpiryDate: action.payload.tradeLicenseExpirayDate == null ? "" : appUtility.formatDate(action.payload.tradeLicenseExpirayDate),
                    policyEmail: action.payload.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.emailId,
                    entityType: action.payload.entityType,
                    entityId: action.payload.entityId,
                    companyMobile: action.payload.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL ? null : action.payload.phoneNo,
                    customerId: action.payload.customerId,
                    customerInPolicyYN: action.payload.customerInPolicyYN,
                    salaryBandTypeId: action.payload.salaryBandTypeId,
                    address: action.payload.address,
                    poBox: action.payload.poBox,
                }
            }
        case types.UPDATE_CUSTOMER_INFORMATION_PARAMS:
            return {
                ...state,
                customerInformation: {
                    ...state.customerInformation,
                    [action.payload.name]: action.payload.value
                }
            }
        case types.SET_UTM_SOURCE:
            return {
                ...state,
                utmSource: action.payload
            }
        default:
            return state;
    }
}